<template>
    <div v-if="active&&!confirming" :class="{'uk-active': !!active}" class="lam-template-picker">
        <div class="uk-panel uk-panel-box">
            <a href="" class="uk-close uk-close-alt uk-float-right" @click.prevent="close"></a>
            <h3 class="uk-panel-title">{{ title }}</h3>

            <ul class="uk-list uk-list-line uk-list-space">
                <li v-for="template in templates" :key="template.id" :class="{'uk-active':template.id===template.id}" class="lam-hoverable">
                    <div class="uk-grid uk-grid-small" data-uk-grid-margin>
                        <div class="uk-width-7-10" @click.prevent="$emit('load', template)">
                            {{ template.name }}
                        </div>
                        <div class="uk-width-3-10 uk-text-right lam-show-on-hover">
                            <a href class="uk-button-sm uk-button-primary uk-icon-trash uk-margin-right" @click.prevent="template_delete(template)"></a>
                            <a href class="uk-button-sm uk-button-primary uk-icon-clone" @click.prevent="$emit('clone', template)"></a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

export default {
    methods: {
        close () {
            this.$emit("close")
        },
        template_delete (template) {
            if(!template.id) return

            this.confirming = true
            this.$confirm(
                {
                    type: "error",
                    title: this.$root.translate("Delete Template"),
                    message: this.$root.translate(`Do you really want to delete the template "${template.name}"? Once it's gone, it's gone...`),
                    cancel: this.$root.translate("Keep it"),
                    ok: this.$root.translate("Delete it"),
                    then: (confirmed) => {
                        if(confirmed) {
                            this.$store.dispatch("RECORD_DELETE", {
                                entity: "user_preference",
                                id: template.id
                            }).then(() => {
                                this.$emit("deleted", template)
                            })
                        }
                        this.confirming = false
                    }
                },
                "delete-template"
            )
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        preferences () {
            return this.entity_records("user_preference")
        },
        templates () {
            if(!this.preferences) return []
            return this.preferences.filter(preference => {
                return (preference.category === this.category) && (preference.entity === this.entity)
            })
        }
    },
    props: {
        entity: {
            type: String,
            required: true
        },
        template: {
            type: Object,
            required: true
        },
        active: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        category: {
            type: String,
            default: "export-columns" // "export-columns" or "filters"
        }
    },
    data () {
        return {
            confirming: false
        }
    }
}
</script>
